import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import QuickSearch from 'components/QuickSearch';
import { fetchQuickSearch, clearSearch } from 'ducks/quicksearch';
import withRouting from 'utils/withRouting';

class QuickSearchContainer extends Component {
  static propTypes = {
    router: PropTypes.object,
    dispatch: PropTypes.any,
    items: PropTypes.any,
    entityDefinitions: PropTypes.any,
  };

  submitSearch: Function = (event, value) => {
    let { entityDefinitions } = this.props;
    let { params } = this.props.router;
    let { program, project } = params;
    let entityTypes = ((entityDefinitions || {}).defs || []).filter(n => (n.properties || {}).hasOwnProperty('submitter_id')).map(n => n.id);
    this.props.dispatch(fetchQuickSearch({
      first: 10,
      quickSearch: value,
      program: program,
      project: project,
      entityTypes: entityTypes,
    }));
  };

  clearSearch: Function = () => {
    this.props.dispatch(clearSearch());
  };

  render(): React.Element {
    let { entityDefinitions, items, isFetching } = this.props;
    let { params } = this.props.router;
    let { program, project } = params;
    let categoryMapping = entityDefinitions.defs.reduce((acc, n) => {
      return {...acc, [n.id]: n.category};
    }, {});
    return (
      <QuickSearch
        handleSubmit={ this.submitSearch }
        handleClear={ this.clearSearch }
        projectID={ project ? `${program}-${project}` : null }
        items={items}
        isFetching={isFetching}
        categoryMapping={categoryMapping}
      />
    );
  }
}

export default connect(
  state => ({
    items: state.quicksearch.items,
    isFetching: state.quicksearch.isFetching,
    entityDefinitions: state.entityDefinitions,
  })
)(withRouting(QuickSearchContainer));
